export default __webpack_public_path__ + "static/media/the-last-of-us_0.a87eef4e.jpg";